import {
  Tooltip,
  type TooltipProps,
  Typography,
  type TypographyProps
} from '@mui/material'
import React, { type ElementType, type PropsWithChildren } from 'react'

/**
 * param `tooltipProps` is mandatory because an object with
 * at least { title: string } must be passed in for the tooltip to appear
 * (an empty string title won't render the tooltip)
 *
 * @example ```
 * const title = condition ? 'title' : ''
 * return <TruncatedTextWithTooltip tooltipProps={{ title }}>Text</TruncatedTextWithTooltip>
 * ```
 */
export function TruncatedTextWithTooltip({
  children,
  tooltipProps,
  ...rest
}: PropsWithChildren<
  Omit<TypographyProps, 'children'> & {
    component?: ElementType
    tooltipProps: Omit<TooltipProps, 'children'>
  }
>) {
  return (
    <Tooltip arrow placement="top" {...tooltipProps}>
      <Typography noWrap {...rest}>
        {children}
      </Typography>
    </Tooltip>
  )
}
